import {
    Button, Dialog, DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider, Grid, TextField,
} from "@mui/material";
import React, {useState} from "react";
import {Send} from "react-feather";
import {Controller, useForm} from "react-hook-form";
import ValidationError from "../../shared/ValidationError";
import {GrantAccountStatementService} from '../shared/service';
import { Alert } from '@mui/material';


const ValidateFile = (props) => {
    const methods = useForm();
    const {handleSubmit, control, errors} = methods;
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const onSubmit = d => {
        GrantAccountStatementService
            .setFile(props.data.id, {documentLocation: d.link})
            .then((response) => {
                    if(response.data.error){
                        setErrorMessage("There was an error finding the file you provided. " +
                            "Please make sure the google drive file you provided is " +
                            "in the designated google drive folder so that the tool has permission to access it. " +
                        response.data.message);
                    }else{
                        setMessage("The document location has been set correctly.");
                    }

                }).catch((response)=>{
                    setErrorMessage("There was an error finding the file you provided. " +
                        "Please make sure the google drive file you provided is " +
                        "in the designated google drive folder so that the tool has permission to access it.");
                })
    }

    return (<>

        <Dialog open={props.open} onClose={props.handleClose} aria-labelledby="form-dialog-title">
            <form onSubmit={handleSubmit(onSubmit)}>
                <DialogTitle id="form-dialog-title">Provide File Path</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        You can use this form to provide a link to a specific link to a grant account statement.
                    </DialogContentText>
                    <Divider/>
                    {
                        message && <Alert severity="success">{message}</Alert>
                    }
                    {
                        errorMessage && <Alert severity="error">{errorMessage}</Alert>
                    }
                    <Grid container spacing={3}>

                        <Grid item xs={12}>
                            <Controller
                                name="link"
                                control={control}
                                fullWidth
                                as={<TextField/>}
                                label="Google Drive File Link"
                                color="primary"
                                variant="outlined"
                                rules={{required: 'Link is required.'}}
                            />
                            <ValidationError error={errors.link}/>
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="contained"
                            type="submit"> <Send/> Add Path</Button>
                    <Button onClick={props.handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </form>
        </Dialog>

    </>);
}

export default ValidateFile;